import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import HeadTitle from "./Componentes/HeadTitle/HeadTitle";
import MentoresSection from "./Componentes/MentoresSection/MentoresSection";

function Mentores(){
    return(
        <>
        <Header/>
        <HeadTitle/>
        <MentoresSection/>
        </>
    )
}

export default Mentores;